import { useEffect, useState } from "react";
import api from "../lib/api";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

let cache = null;
const loadOwners = () => {
  if (!cache) cache = api.get("/crm/hubspot/owners").then(({ data }) => data).catch(() => ({ owners: [] }));
  return cache;
};

export function useHubspotOwners() {
  const [data, setData] = useState({ owners: [], scope_missing: false, loaded: false });
  useEffect(() => { loadOwners().then((d) => setData({ ...d, loaded: true })); }, []);
  return data;
}

const NONE = "__none__";

export function HubspotOwnerSelect({ value, onChange }) {
  const { owners, scope_missing: missing, loaded } = useHubspotOwners();
  if (loaded && !owners.length) {
    return (
      <div>
        <Input data-testid="lead-owner" value={value.owner || ""} onChange={(e) => onChange({ owner: e.target.value })} />
        {missing && <p className="text-[10px] text-brand-gold mt-1" data-testid="lead-owner-scope-note">HubSpot owners list needs the owners scope. Type a name for now.</p>}
      </div>
    );
  }
  const current = value.hubspot_owner_id || (owners.find((o) => o.name === value.owner)?.id) || NONE;
  return (
    <Select value={current} onValueChange={(id) => {
      const o = owners.find((x) => x.id === id);
      onChange(o ? { hubspot_owner_id: o.id, owner: o.name } : { hubspot_owner_id: null, owner: "" });
    }}>
      <SelectTrigger data-testid="lead-owner"><SelectValue placeholder="Select owner" /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>Unassigned</SelectItem>
        {owners.filter((o) => !o.archived || o.id === current).map((o) => (
          <SelectItem key={o.id} value={o.id} data-testid={`lead-owner-opt-${o.id}`}>{o.name}{o.archived ? " (deactivated)" : ""}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
